
export default (state = ['Best Match', 'Newest', 'Related Threats', 'Related Solutions', 'Rating', 'Views', 'Comments', 'Shares', 'Post Date'], action) => {
    if (action.type === 'SORT_OPTIONS') {
        return action.payload;
    }

    return state;
}